import { LucideIcon } from "lucide-react";
import { IconType } from "react-icons";

type IconProps = {
  Icon: LucideIcon | IconType;
  className?: string;
  overrideColor?: boolean;
};

export function IconWrapper({ Icon, className = "", overrideColor = false }: IconProps) {
  const baseClasses = "h-[20px] w-[20px]";
  const colorClass = overrideColor ? "" : "text-[#2B0C1A]";
  
  return <Icon className={`${baseClasses} ${colorClass} ${className}`} />;
}
